import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
	providedIn: 'root',
})
export class AuthGuardService {
	public constructor(public auth: AuthService, public router: Router) {}
	public canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		const urlTree = this.router.parseUrl('/login');

		if (!this.auth.isAuthenticated()) {
			this.auth.setReturnUrl(state.url);
			return urlTree;
		}
		return this.auth.isAuthenticated() ? true : urlTree;
	}
}
